import React from "react";
import "./Header.scss";
import HeaderMain from "./subcomponents/HeaderMain";

const Header = () => {
	return (
		<div className='container1'>
			<HeaderMain />
		</div>
	);
};

export default Header;
